import { IGetAllLogAlteracaoByParentUseCase } from "../../../presentation/useCases/read/get_all_log_alteracao_by_parent_use_case";
import { LogTipoTabela } from "../../../utils/log_tabela_tipo";
import { LogAlteracao } from "../../models/log_alteracao";
import { ICommonsRepository } from "../../repositories/commons_repository";
import { BasePaginatedUseCase } from "../base_paginated_use_case";

/**
 * GetAllLogAlteracaoByParentUseCase
 */

export class GetAllLogAlteracaoByParentUseCase
  extends BasePaginatedUseCase<LogAlteracao>
  implements IGetAllLogAlteracaoByParentUseCase {
  constructor(private readonly repository: ICommonsRepository) {
    super();
  }

  async getAllLogAlteracaoByParent(
    tipoTabelaPai: LogTipoTabela,
    idTabela: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllLogAlteracaoByParent(
      tipoTabelaPai,
      idTabela,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
